import { useTranslation } from 'react-i18next';
import StatusCompleteIcon from 'wix-ui-icons-common/StatusComplete';
import * as React from 'react';
import s from '../RequestCall.scss';
import { Text, Button } from 'wix-style-react';
import { withInjectedRootStore, RootStore } from '../../../providers';
import { Theme } from '../../../enums';

export interface SuccessMessageProps {
  onDismissClick(): void;
  rootStore: RootStore;
}

const SuccsessMessageComp: React.FC<SuccessMessageProps> = ({
  onDismissClick,
  rootStore,
}) => {
  const { t } = useTranslation();
  const { theme } = rootStore.appStore.appContext.pageMode;
  const successMessage =
    theme === Theme.EditorX
      ? 'premium_plan.editorx_business_enterprise.request_call_success_message.text'
      : 'premium_plan.business_enterprise.request_call_success_message.text';
  return (
    <div data-hook='request-call-success' className={s.succsessMessageWrapper}>
      <StatusCompleteIcon
        className={s.statusCompleteIcon}
        width='68px'
        height='68px'
      />
      <Text weight='normal' className={s.messageText}>
        <span>{t(successMessage)}</span>
      </Text>
      <Button onClick={onDismissClick}>
        {t(
          'premium_plan.business_enterprise.request_call_success_message.im_done',
        )}
      </Button>
    </div>
  );
};

export const SuccsessMessage = withInjectedRootStore(SuccsessMessageComp);
